
// Feature flags for MasterJi application
export const FEATURES = {
  // SMS/2FA Configuration
  SMS_VERIFICATION_ENABLED: false, // Set to true when Twilio verification is complete
  SMS_VERIFICATION_REQUIRED: false, // Set to true to make SMS mandatory
  
  // Other feature flags can be added here
  AI_BODY_SCAN: false,
  ADVANCED_ANALYTICS: false,
  MOBILE_APP: false,
  CHAT_ENABLED: import.meta.env.VITE_CHAT_ENABLED === 'true',
} as const;

// Helper function to check if SMS verification is enabled
export const isSMSVerificationEnabled = (): boolean => {
  return FEATURES.SMS_VERIFICATION_ENABLED;
};

// Helper function to check if SMS verification is required
export const isSMSVerificationRequired = (): boolean => {
  return FEATURES.SMS_VERIFICATION_ENABLED && FEATURES.SMS_VERIFICATION_REQUIRED;
};

// Helper function to check if chat is enabled
export const isChatEnabled = (): boolean => {
  const enabled = FEATURES.CHAT_ENABLED;
  console.log('Chat enabled:', enabled, 'VITE_CHAT_ENABLED:', import.meta.env.VITE_CHAT_ENABLED);
  return enabled;
};
